// extracted by mini-css-extract-plugin
export var copyableField = "_mh-4";
export var customerBadge = "_mh-0";
export var customerInfoTitle = "_mh-2";
export var details = "_mh-1";
export var dropdownContainer = "_mh-5";
export var dropdownImage = "_mh-6";
export var editAssigneeForm = "_mh-a";
export var editButton = "_mh-3";
export var email = "_mh-7";
export var hidden = "_mh-d";
export var input = "_mh-8";
export var saveButton = "_mh-b";
export var shopifyIcon = "_mh-c";
export var suggestionBadge = "_mh-e";
export var suggestionText = "_mh-f";
export var username = "_mh-9";